import styles from "./TeleOp.module.css";
import React, {useContext} from "react";
import goldBg from "../../static_files/buttonBackgroundGold.svg";
import {useNavigate} from "react-router-dom";
import {SwapMainAppContext} from "../../context/SwapMainAppContext";

const InfoBox = ({robotId}) => {
    const navigate = useNavigate();
    const {
        showNotification,
        livePaused
    } = useContext(SwapMainAppContext);

    const handleTeleOpClick = () => {
        const isEveryRobotPaused = Object.values(livePaused || {}).every(value => !!value);
        if (isEveryRobotPaused) {
            showNotification('warning', 'We\'re on a break, the live streaming will be restarted soon!')
        } else {
            navigate('/robots-center');
        }
    }
    return (
        <div className={styles.infoBox}>
            <p>
                Take direct robot control for real-time missions.
                Help advance robotic vision-language action models and
                earn Prisma Points for your impact.
            </p>
          
          
            <button
                className={styles.infoBoxLiveControlButton}
                onClick={handleTeleOpClick}
            >
                Enter Live Control
            </button>
        </div>

    );
};

export default InfoBox
